module.exports = __webpack_public_path__ + "assets/img/help_pagination04-2.cf54f402.svg";